<template>
  <div class="col-md-12 px-2 py-0 mt-5">
        <table
            v-if="arrayModel.length > 0"
            class="table table-bordered table-striped table-sm"
        >
            <thead>
                <tr>
                    <th>Opciones</th>
                    <th>Enunciado</th>
                    <th>Variable</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="model in arrayModel" :key="model.id">
                    <td>
                        <button
                            type="button"
                            @click="changeView(model.id)"
                            class="btn btn-warning btn-sm"
                        >
                            <em class="fa fa-pencil"></em>
                        </button>

                        <button
                            v-if="pass == 0"
                            @click="deleteModel(model.id)"
                            type="button"
                            class="btn btn-danger btn-sm"
                            disabled
                        >
                            <em class="fa fa-trash"></em>
                        </button>
                        <button
                            v-else
                            @click="deleteModel(model.id)"
                            type="button"
                            class="btn btn-danger btn-sm"
                        >
                            <em class="fa fa-trash"></em>
                        </button>
                    </td>
                    <td v-text="model.question"></td>
                    <td v-text="model.slug"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            pass: null,
            arrayModel: [],
        };
    },
    methods: {
        getListModel(page = 1) {
            let me = this;
            axios
                .get("/api/contests/config-questions?paginate=false&contest_id=" + me.model_id)
                .then(function (response) {
                    me.arrayModel = response.data;
                })
                .catch(function (error) {});
        },
        changeView(id) {
            this.$emit("change", id);
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
        showActionError(message) {
            let Toast = this.$swal.mixin({
                toast: true,
                icon: "error",
                position: "top-end",
                showConfirmButton: false,
                timer: 6000,
            });

            Toast.fire({
                type: "error",
                title: message,
            });
        },
        deleteModel(id) {
            let me = this;
            this.$swal({
                title: "Esta seguro?",
                text: "No podra revertir este cambio!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Si, borrarlo!",
            }).then((result) => {
                if (result.value) {
                    axios
                        .delete("/api/contests/config-questions/" + id)
                        .then(function (response) {
                            me.getListModel();
                            me.showActionSuccess("Borrado exitoso!");
                        })
                        .catch(function (error) {
                            if (error.response) {
                                let errors = error.response.data.messages;
                                me.showActionError(errors);
                            }
                        });
                }
            });
        },
    },
    mounted() {
        this.getListModel();
    },
};
</script>
